<template>
  <div class="d-flex flex-column-fluid">
    <!--begin::Container-->
    <div class="container">
      <!--      <span style="position: absolute; top:-70px; right:0px; z-index: 10000">-->
      <!--        <button-->
      <!--          ref="refresh"-->
      <!--          :disabled="isBusy"-->
      <!--          class="btn btn-light font-weight-bolder font-size-sm mx-1"-->
      <!--          @click="submitsearch"-->
      <!--        >-->
      <!--          <i class="flaticon2-refresh"></i>Refresh-->
      <!--        </button>-->
      <!--      </span>-->
      <div class="row">
        <div class="col-12">
          <div class="card card-custom gutter-b">
            <div class="card-body">
              <b-form-group label="Branch" label-for="businessprofileid">
                <b-form-select v-model="form.BusinessProfileId" :options="profiles"
                               class="form-control form-control-solid h-auto py-3 px-3"
                               name="businessprofileid" placeholder="Revenue District Office" size="sm"></b-form-select>
              </b-form-group>
              <b-form-group label="File Type" label-for="fileType">
                <b-form-select v-model="form.fileType" :options="fileTypes"
                               class="form-control form-control-solid h-auto py-3 px-3"
                               name="fileType" placeholder="File Type" size="sm"></b-form-select>
              </b-form-group>
              <b-form-file
                  v-model="form.file"
                  :state="Boolean(form.file)"
                  drop-placeholder="Drop file here..."
                  placeholder="Choose a file or drop it here..."
              ></b-form-file>
              <b-form-textarea
                  v-model="form.remarks"
                  class="form-control form-control-solid h-auto py-3 px-3 mt-2 mb-2"
                  max-rows="8"
                  name="Remarks"
                  placeholder="Remarks"
                  rows="5"
                  size="sm"
              ></b-form-textarea>
              <button
                  ref="submit"
                  :disabled="this.isBusy || !Boolean(form.file)"
                  class="btn btn-primary mr-2"
                  type="button"
                  @click="submit"
              >
                Upload
              </button>
              <b-button>Download sample file</b-button>
            </div>
          </div>
          <div class="card card-custom gutter-b">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-head-custom table-head-bg table-borderless table-vertical-center table-hover">
                  <thead>
                  <tr class="text-uppercase">
                    <th class="pl-7">
                      <span class="text-dark-75">Date</span>
                    </th>
                    <th class="text-dark-75">Branch</th>
                    <th class="text-dark-75">FileType</th>
                    <th class="text-dark-75">FileName</th>
                    <th class="text-dark-75">Status</th>
                    <th class="text-dark-75">User Remarks</th>
                    <th class="text-dark-75">Remarks</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in items.data" :key="item.BulkInvoiceId">
                    <!--              <tr>-->
                    <td class="py-2">
                      <span class="d-block">{{
                          item.UploadDateTimeString
                        }}</span>
<!--                      <div class="d-flex align-items-center">-->
<!--                        <a :href="'http://reports-test.thirdchannel.ph/reportserver/reportserver/httpauthexport?p_RP_TIN='+item.TIN+'&key=BIR_SS_ALL&user=EasyReceiptRO&apikey=79PKXGScP8r8&format=pdf&download=false'"-->
<!--                           class="text-primary font-weight-bolder text-hover-secondary mb-1 font-size-lg"-->
<!--                           target="_blank">-->
<!--                          {{ item.UploadDateTime }}-->
<!--                        </a>-->
<!--                      </div>-->
                    </td>
                    <td>
                    <span class="d-block">{{
                        getBranchName(item.BusinessProfileId)
                      }}</span>
                    </td>
                    <td>
                    <span class="d-block">{{
                        item.FileType
                      }}</span>
                    </td>
                    <td>
                    <span class="d-block">{{
                        item.FileName
                      }}</span>
                    </td>
                    <td>
                    <span class="d-block">{{
                        item.Status
                      }}</span>
                    </td>
                    <td>
                    <span class="d-block">{{
                        item.UserRemarks
                      }}</span>
                    </td>
                    <td>
                    <span class="d-block">{{
                        item.Remarks
                      }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--end::Table-->
            </div>
          </div>
        </div>
      </div>
      <!--end::Row-->

      <!--begin::Pagination-->
      <div class="card card-custom">
        <div class="card-body pt-0 pb-2">
          <Paginator v-bind:currentPage="search.currentPage" v-bind:rowsPerPage="search.rowsPerPage"
                     v-bind:totalRows="items.totalRows" @update-currentpage="
              value => {
                search.currentPage = value;
                this.submitsearch();
              }
            " @update-pagesize="
              value => {
                search.currentPage = 1;
                setPageSize(value);
              }
            "/>
        </div>
      </div>
      <!--end::Pagination-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import Paginator from "@/view/content/widgets/paginator2.vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

Vue.use(vueNumeralFilterInstaller);
Vue.use(require("vue-moment"));
Vue.filter("numFormat", numFormat(numeral));

export default {
  mixins: [validationMixin],
  components: {Paginator},
  data() {
    return {
      isBusy: false,
      filters: {},
      options: {
        Users: []
      },
      form: {
        BusinessProfileId: "",
        fileType: "",
        file: null,
        remarks: ""
      },
      search: {
        currentPage: 1,
        rowsPerPage: 6,
        RDO: "",
        TIN: "",
        BusinessName: ""
      },
      items: {
        data: [],
        totalRows: 0,
        indexStart: 0
      },
      profiles: [],
      fileTypes: []
    };
  },
  validations: {
    form: {
      BusinessProfileId: { required },
      fileType: { required },
      file: {required},
      remarks: {required},
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "currentUser"]),
    config() {
      return this.layoutConfig();
    },
    currentPage() {
      return this.search.currentPage;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("Bulk e-Invoice");
      this.resetForm();
      this.getProfiles();
      this.getFileTypes();

    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreceipt"
        }];
      payload.push({title: value});
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    validateState(name, container) {
      if (container) {
        const { $dirty, $error } = container[name];
        return $dirty ? !$error : null;
      } else {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    resetForm() {
      this.form = {
        file: null,
        remarks: ""
      };
      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    submit: function(e) {
      e.preventDefault();
      if (this.form.file === null) return;
      this.submitFile();
      console.log('submit:', this.form);
    },
    submitFile() {
      let self = this;
      self.isBusy = true;
      let param = new FormData();
      param.append("BusinessProfileId", self.form.BusinessProfileId);
      param.append("FileType", self.form.fileType);
      param.append("Remarks", self.form.remarks);
      param.append("File", self.form.file);
      const submitButton = self.$refs["submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.upload("business/createbulkinvoice", param)
          .then(({data}) => {
            //this.$gtag.event("files_create", param);
            if (data) {
              self.isBusy = false;
              self.file = null;
              self.resetForm();
              submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
              this.submitsearch();
            }
          })
          .catch(() => {
            self.isBusy = false;
            submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
          });
    },

    setPageSize(value) {
      this.search.rowsPerPage = value;
      this.submitsearch();
    },
    submitsearch() {
      var self = this;
      self.isBusy = true;
      return new Promise(resolve => {
        let param = {
          currentPage: self.search.currentPage,
          rowsPerPage: self.search.rowsPerPage
        };
        // this.$gtag.event("admin_search", {
        //   search_term: JSON.stringify(param)
        // });
        ApiService.get("business/searchbulkinvoice", param)
            .then(({data}) => {
              self.items.data = data.Items;
              self.items.totalRows = data.TotalRows;
              self.items.indexStart = (self.search.currentPage - 1) * self.search.rowsPerPage;
              self.isBusy = false;

              window.scrollTo(0, 0);
              resolve(data);
              return data;
            })
            .catch(() => {
              self.items.data = [];
              self.items.totalRows = 0;
              self.isBusy = false;
              window.scrollTo(0, 0);
            });
      });
    },
    getProfiles() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = {};
        ApiService.get("business/myprofiles", param)
            .then(({ data }) => {
              this.$gtag.event("business_myprofiles", param);
              self.profiles = data;
              self.form.BusinessProfileId = data[0].value;
              self.isBusy = false;
              this.submitsearch();
              resolve(data);
            })
            .catch(({ response }) => {
              self.isBusy = false;
              reject(response);
            });
      });
    },
    getFileTypes() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = {};
        ApiService.get("business/getbulkuploadfiletypes", param)
            .then(({ data }) => {
              this.$gtag.event("business_myfiletypes", param);
              self.fileTypes = data;
              self.form.fileType = data[0].value;
              self.isBusy = false;
              resolve(data);
            })
            .catch(({ response }) => {
              self.isBusy = false;
              reject(response);
            });
      });
    },
    getBranchName(id) {
      var matchData = this.profiles.filter(function (item) { return item.value === id; })
      console.log('matchData:', matchData, this.profiles);
      if (matchData.length > 0) {
        return matchData[0].text
      }
      return "";
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      if (newValue != oldValue) {
        this.submitsearch();
      }
    }
  }
};
</script>
